export function getCookie(name) {
  let arr = []
  let reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
  return (arr = document.cookie.match(reg)) ? unescape(arr[2]) : null
}



// WEBPACK FOOTER //
// ./src/utils/cookie.js